import { formatBytes } from '@jwplayer/fe-common/module/format/bytes';

export const bytesToSize = (bytes: number): string => formatBytes(bytes).string;
